//widgets/_new/cards/vendors/distribution/accounts/OpenPOCard.tsx

import React, { FC } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBoxOpen } from '@fortawesome/free-solid-svg-icons'

interface Props {
  quantity: number   // total open‑order units
  orders:   number   // open‑PO count
}

const OpenPOCard: FC<Props> = ({ quantity, orders }) => (
  <div className='card h-100 min-h-100' style={{background:'linear-gradient(45deg,#6155D4,#5B97F2)', minHeight: '13rem',}}>
    <div className='h-auto rounded-top p-4'>
      <header style={{fontSize:'2rem'}}><FontAwesomeIcon icon={faBoxOpen}/></header>
      <div className='pt-3 pb-3 d-flex flex-column'>
        <div className='fw-bolder' style={{fontSize:'3rem',lineHeight:'1'}}>
          {quantity.toLocaleString()}
        </div>
        <div className='pt-2 fw-bold' style={{fontSize:'1.15rem'}}>Total Quantity</div>
      </div>
    </div>
    <div style={{height:1,width:'auto',margin:'0 50% 0 5%',background:'rgba(255,255,255,.5)'}}/>
    <footer className='h-auto rounded-bottom pt-3 pb-3 px-4'>
      <div className='d-flex align-items-center'>
        <div className='fs-1 fw-bold'>{orders}</div>
        <div className='text-body-secondary fw-bold ms-2'>Open Purchase Orders</div>
      </div>
    </footer>
  </div>
)


export { OpenPOCard }